import React, { useState } from "react";

import LocaleDropdown from "../../i18n/i18n-dropdown.json";

import { CwsA } from "cms-web-styleguide/dist/components/CwsA/CwsA";
import { CwsDropdown } from "cms-web-styleguide/dist/components/CwsForm/CwsDropdown/CwsDropdown";
import { CwsDropdownButton } from "cms-web-styleguide/dist/components/CwsForm/CwsDropdown/CwsDropdownButton/CwsDropdownButton";
import { CwsDropdownMenu } from "cms-web-styleguide/dist/components/CwsForm/CwsDropdown/CwsDropdownMenu/CwsDropdownMenu";
import { CwsDropdownMenuItem } from "cms-web-styleguide/dist/components/CwsForm/CwsDropdown/CwsDropdownMenu/CwsDropdownMenuItem/CwsDropdownMenuItem";
import { CwsIcon } from "cms-web-styleguide/dist/components/CwsIcon/CwsIcon";

import { parseLocale } from "../../utils/utils";

import styles from "./Dropdown.module.scss";

const Dropdown = (props) => {
  const { env, handleLocaleChange, locale } = props;

  const [open, setOpen] = useState(false);

  const currentLocale = parseLocale(locale);

  const bannerDropdownLanguages = env && currentLocale.market ? LocaleDropdown[env][currentLocale.market] : null;

  const langByLangCode = bannerDropdownLanguages?.find((lang) => lang["lang"] === currentLocale.lang);

  const [langTitle, setLangTitle] = useState(langByLangCode?.title);

  const changeLanguage = (lang, market, title) => {
    if (handleLocaleChange) {
      handleLocaleChange(`${lang}-${market}`);
      setLangTitle(title);
    }

    setOpen(false);
  };

  return langByLangCode && bannerDropdownLanguages?.length ? (
    <CwsDropdown
      className={styles["cwc-language-dropdown"]}
      id="cwc-language-dropdown"
      open={open}
      setOpen={(status) => setOpen(status)}
    >
      <CwsDropdownButton aria-label="Choose your language:">
        <CwsIcon icon="global-menu" mode="dom" size="24px" />
      </CwsDropdownButton>

      <CwsDropdownMenu className={styles["cwc-language-dropdown__menu"]}>
        {bannerDropdownLanguages.map((item, index) => {
          const market = item.market ?? currentLocale.market;

          return (
            <CwsDropdownMenuItem active={langTitle === item.title} key={index} iconMode="dom">
              <CwsA onClick={() => changeLanguage(item.lang, market, item.title)}>{item.title}</CwsA>
            </CwsDropdownMenuItem>
          );
        })}
      </CwsDropdownMenu>
    </CwsDropdown>
  ) : null;
};

export { Dropdown };
